import { css } from 'lit';

export default css`
  :host {
    display: contents;
    margin: 0;
  }

  .alert {
    position: relative;
    display: flex;
    align-items: stretch;
    background-color: var(--webmodule-panel-background-color);
    border: solid var(--webmodule-panel-border-width) var(--webmodule-panel-border-color);
    border-top-width: calc(var(--webmodule-panel-border-width) * 3);
    border-radius: var(--webmodule-border-radius-medium);
    font-family: var(--webmodule-font-sans);
    font-size: var(--webmodule-font-size-small);
    font-weight: var(--webmodule-font-weight-normal);
    line-height: 1.6;
    color: var(--webmodule-color-neutral-700);
    margin: inherit;
  }

  .alert:not(.alert--has-icon) .alert__icon,
  .alert:not(.alert--closable) .alert__close-button {
    display: none;
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--webmodule-font-size-large);
    padding-inline-start: var(--webmodule-spacing-large);
  }

  .alert--primary {
    border-top-color: var(--webmodule-color-primary-600);
  }

  .alert--primary .alert__icon {
    color: var(--webmodule-color-primary-600);
  }

  .alert--success {
    border-top-color: var(--webmodule-color-success-600);
  }

  .alert--success .alert__icon {
    color: var(--webmodule-color-success-600);
  }

  .alert--neutral {
    border-top-color: var(--webmodule-color-neutral-600);
  }

  .alert--neutral .alert__icon {
    color: var(--webmodule-color-neutral-600);
  }

  .alert--warning {
    border-top-color: var(--webmodule-color-warning-600);
  }

  .alert--warning .alert__icon {
    color: var(--webmodule-color-warning-600);
  }

  .alert--danger {
    border-top-color: var(--webmodule-color-danger-600);
  }

  .alert--danger .alert__icon {
    color: var(--webmodule-color-danger-600);
  }

  .alert__message {
    flex: 1 1 auto;
    display: block;
    padding: var(--webmodule-spacing-large);
    overflow: hidden;
  }

  .alert__close-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--webmodule-font-size-medium);
    padding-inline-end: var(--webmodule-spacing-medium);
  }

  .alert--snack .alert__message {
    padding-top: var(--webmodule-spacing-2x-small);
    padding-bottom: var(--webmodule-spacing-2x-small);
  }
`;
